import axios from 'axios';

const state= {
    equipCats: [],
    equipBrands: [],
    equipBrandsByID: [],
    equipModels: [],
    equipments:{
        items:[],
        total:0,
        filter: null
    },
    equipmentLoading: {
        listing: false,
        category:false,
        import: false
    },
    equipmentCategory:[],
    contractId:0,
    infoRedirect : {
        location_id : null,
        location : null,
        equipment_category_id : null,
        equipment_category : null,
        equipment_group_id : null,
        equipment_type : null,
    },
    dataTreeProperty : [],
    dataTreeStructure : [],
    filter : {
        tag:null,
        model:null,
        brand:null,
        equipment_type:null,
        equipment_category:null,
        serial_number:null,
        location:null,
        location_id:null,
        equipment_category_id:null,
    }
};

const getters = {
    ListEquipCats : (state) => state.equipCats,
    ListEquipBrands : (state) => state.equipBrands,
    ListEquipBrandsID : (state) => state.equipBrandsByID,
    ListEquipModels : (state) => state.equipModels,
    contractId : (state) => state.contractId,
    equipments : (state) => state.equipments,
    equipmentLoading : (state) => state.equipmentLoading,
    equipmentCategory : (state) => state.equipmentCategory,
    infoRedirect : (state) => state.infoRedirect,
    dataTreeProperty : (state) => state.dataTreeProperty,
    dataTreeStructure : (state) => state.dataTreeStructure,
    filter : (filter) => state.filter
};

const actions = {
    async getEquipmentStucture({commit}, params){
        let page = params.page;
        let limit = params.limit;
        let filter = params.filter;
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/equipment/structure`, {params:{
                contract_id : filter.contract_id,
                page:page,
                limit:limit,
                filter:filter,
            }})
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async getEquipments({commit}, params){
        let page = params.page;
        let limit = params.limit;
        let filter = params.filter;
        return new Promise (( resolve, reject ) => {
            commit( 'setLoading', {key: "listing",val : true} );
            global.axios.get(`api/equipment`, {params:{
                    page:page,
                    limit:limit,
                    filter:filter,
                }})
                .then(response => {
                    response.data.data.filter = filter
                    commit( 'setLoading', {key: "listing",val : false} );
                    commit( 'setItems', response.data.data );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async getEquipmentCategory({commit}, params){
        let id = params.id || 1;
        let type = params.type || null;
        return new Promise (( resolve, reject ) => {
            commit( 'setLoading', {key: "category",val : true} );
            global.axios.get(`api/equipment/tree-structure/${id}`,{
                params:{
                    type:type
                }
            })
                .then(response => {
                    commit( 'setLoading', {key: "category",val : false} );
                    //commit( 'setItems', response.data.data );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async deleteEquipment({commit}, ids){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/equipment`,{
                data:{
                    ids:ids
                }
            })
                .then(response => {
                    //commit( 'setGroup', response.data.data );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async createEquipment({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/equipment`, {
                method: "POST",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    commit('addListEquipment',response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async updateEquipment({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/equipment/${params.id}`, {
                method: "PUT",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async getEquipment({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/equipment/${params}`, {
                method: "GET",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    /*Equipment Categories*/
    async GetEquipmentStructure({commit}, params){

        return new Promise (( resolve, reject ) => {

            global.axios(`/api/equipment/tree-structure/` + params.id, {
                method: "GET",
                params: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    if(response.data.status == 200) {
                        commit('setListEquipCats', response.data.data)
                    }
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    async GetEquipmentStructureByID({commit}, params){

        return new Promise (( resolve, reject ) => {

            global.axios(`/api/equipment/structure/` + params, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    if(response.data.status == 200) {
                        commit('setListEquipCats', response.data.data)
                    }
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    async CreateEquipmentStructure({commit},params){

        return new Promise (( resolve, reject ) => {

            global.axios(`/api/equipment/structure`, {
                method: "POST",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    if(response.data.status == 200) {
                        commit('StatusController/setequipmentStructure',{ key : 'equipment', value : true }, { root: true });
                        commit('setListEquipCats', { id: response.data.data.id, data: response.data.data })
                    }
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    async UpdateEquipmentStructure({commit},params){

        return new Promise (( resolve, reject ) => {

            global.axios(`/api/equipment/structure/` + params.id, {
                method: "PUT",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    commit('StatusController/setequipmentStructure',{ key : 'equipment', value : true }, { root: true });
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    async DeleteEquipmentStructure({commit},params){

        return new Promise (( resolve, reject ) => {

            global.axios(`/api/equipment/structure/` + params.id, {
                method: "DELETE",
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    commit('StatusController/setequipmentStructure',{ key : 'equipment', value : true }, { root: true });
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    async CreateTypeBrandLink({commit},params){

        return new Promise (( resolve, reject ) => {

            global.axios(`/api/equipment/type-brand-link`, {
                method: "POST",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    if(response.data.status == 200) {
                        let pivot_res = {
                            id: params.brand_id,
                            name: params.name,
                            pivot: response.data.data
                        }
                        commit('setListEquipBrandsID', { id: response.data.data.equipment_group_id, data: { ids: response.data.data.brand_Id, pivot: pivot_res }})
                    }
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async DeleteTypeBrandLink({commit},params){
        return new Promise (( resolve, reject ) => {

            global.axios(`/api/equipment/type-brand-link`, {
                method: "DELETE",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    if(response.data.status == 200) {
                        commit('deleteItemEquipBrandsID', params)
                    }
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    /*Equipment Brands*/
    async GetEquipmentBrandsAll({commit}){

        return new Promise (( resolve, reject ) => {

            global.axios(`/api/equipment/all-brands`, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    if(response.data.status == 200) {
                        commit('setListEquipBrands', response.data.data )
                    }
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    async GetEquipmentBrandsByIdType({commit}, params){

        return new Promise (( resolve, reject ) => {

            global.axios(`/api/equipment/brands/`, {
                method: "GET",
                params: {
                    equipment_group_id: params
                },
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    let arr = []
                    if(response.data.status == 200) {
                        if(response.data.data.length > 0) {
                            response.data.data.forEach(item => arr.push(item.id))
                        }
                    }
                    commit('setListEquipBrandsID', { id: params, data: { ids: arr, pivot: response.data.data }} )

                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    async CreateEquipmentBrands({commit}, params){

        return new Promise (( resolve, reject ) => {

            global.axios(`/api/equipment/brands`, {
                method: "POST",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    if(response.data.status == 200) {
                        commit('updateListEquipBrands', response.data.data)
                    }
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    async UpdateEquipmentBrands({commit},params){
        
        return new Promise (( resolve, reject ) => {

            global.axios(`/api/equipment/brands/` + params.id, {
                method: "PUT",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    if(response.data.status == 200) {
                        commit('updateItemEquipBrands', params)
                    }
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    async DeleteEquipmentBrands({commit},params){

        return new Promise (( resolve, reject ) => {

            global.axios(`/api/equipment/brands/` + params.id, {
                method: "DELETE",
                params: {
                    equipment_group_id: params.equipment_group_id
                },
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    if(response.data.status == 200) {
                        commit('deleteItemEquipBrands',  params.id)
                        commit('deleteItemEquipBrandsID', { equipment_group_id: params.equipment_group_id, brand_id: params.id, pivot_id: params.pivot_id })
                    }
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    /*Equipment Models*/
    async GetEquipmentModelsByIdBrand({commit}, params){

        return new Promise (( resolve, reject ) => {

            global.axios(`/api/equipment/models/`, {
                method: "GET",
                params: {
                    type_brand_id: params
                },
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    if(response.data.status == 200) {
                        commit('setListEquipModels', { id: params, data: response.data.data })
                    }
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    async CreateEquipmentModels({commit}, params){

        return new Promise (( resolve, reject ) => {

            global.axios(`/api/equipment/models`, {
                method: "POST",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    if(response.data.status == 200) {
                        commit('setListEquipModels', { id: params.type_brand_id, data: response.data.data })
                    }
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    async UpdateEquipmentModels({commit},params){

        return new Promise (( resolve, reject ) => {

            global.axios(`/api/equipment/models/` + params.id, {
                method: "PUT",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    if(response.data.status == 200) {
                        commit('updateItemEquipModels', params)
                    }
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    async DeleteEquipmentModels({commit},params){

        return new Promise (( resolve, reject ) => {

            global.axios(`/api/equipment/models/` + params.id, {
                method: "DELETE",
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    if(response.data.status == 200) {
                        commit('deleteItemEquipModels', params)
                    }
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    import({commit},params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            formData.append('import',params.fileImport);
            formData.append('contract_id',params.id);
            commit( 'setLoading', {key:'import',val:true} );
            global.axios.post(`api/equipment/import`,formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    commit( 'setLoading', {key:'import',val:false} );
                    resolve( response );
                })
                .catch(error =>{
                    commit( 'setLoading', {key:'import',val:false} );
                    reject( error )
                } );
        });
    },
};

const mutations = {
    setItems (state,equipments) {
        state.equipments.items = equipments.items;
        state.equipments.total = equipments.total;
        state.equipments.filter = equipments.filter;
    },
    setLoading (state,params) {
        if(params.key === "listing"){
            state.equipmentLoading.listing = params.val;
        }
        if(params.key === "category"){
            state.equipmentLoading.category = params.val;
        }
        if(params.key === "import"){
            state.equipmentLoading.import = params.val;
        }
    },

    setListEquipCats (state, data) {
        state.equipCats = data
    },
    setListEquipBrands (state, data) {
        data.sort((a, b) => (a != null && b!= null && a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1)
        state.equipBrands = data
    },
    updateListEquipBrands (state, data) {
        state.equipBrands.push(data)
        state.equipBrands.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1)
    },
    setListEquipBrandsID (state, data) {
        let index = state.equipBrandsByID.findIndex(item => item.id === data.id)
        if(index == -1) {
            state.equipBrandsByID.push(data)
        }
        else {
            state.equipBrandsByID[index].data.ids.push(data.data.ids)
            state.equipBrandsByID[index].data.pivot.push(data.data.pivot)
            state.equipBrandsByID[index].data.pivot.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1)
        }
    },

    setListEquipModels (state, data) {
        let index = state.equipModels.findIndex(item => item.id === data.id)
        if(index == -1) {
            state.equipModels.push(data)
        }
        else {
            state.equipModels[index].data.push(data.data)
        }
    },

    updateItemEquipBrands (state, params) {
        /*brand*/
        let index = state.equipBrands.findIndex(item => item.id === params.id)
        if(index != -1) {
            state.equipBrands[index].name = params.name
        }
        state.equipBrands.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1)

        /*brand pivot*/
        if(params.equipment_group_id) {
            let index_brand = state.equipBrandsByID.findIndex(item => item.id === params.equipment_group_id)
            if(index_brand != -1) {
                let index_pivot = state.equipBrandsByID[index_brand].data.pivot.findIndex(item => item.id === params.id)
                if(index_pivot != -1) {
                    state.equipBrandsByID[index_brand].data.pivot[index_pivot].name = params.name
                }
                state.equipBrandsByID[index_brand].data.pivot.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1)
            }
        }
        
    },
    updateItemEquipModels (state, params) {
        let index_parent = state.equipModels.findIndex(item => item.id === params.type_brand_id)
        if(index_parent != -1) {
            let index_child =  state.equipModels[index_parent].data.findIndex(item => item.id === params.id)
            if(index_child != -1) {
                state.equipModels[index_parent].data[index_child].name = params.name
            }
        }
    },

    deleteItemEquipBrandsID (state, params) {
        let index_parent = state.equipBrandsByID.findIndex(item => item.id === params.equipment_group_id)
        if(index_parent != -1) {
            let index_ids = state.equipBrandsByID[index_parent].data.ids.findIndex(item => item == params.brand_id)
            if(index_ids != -1) {
                state.equipBrandsByID[index_parent].data.ids.splice(index_ids, 1)
            }
            let index_pivot = state.equipBrandsByID[index_parent].data.pivot.findIndex(item => item.pivot.id == params.pivot_id)
            if(index_pivot != -1) {
                state.equipBrandsByID[index_parent].data.pivot.splice(index_pivot, 1)
            }
        }
    },

    deleteItemEquipBrands (state, params) {
        let index = state.equipBrands.findIndex(item => item.id === params)
        if(index != -1) {
            state.equipBrands.splice(index, 1)
        }
    },
    deleteItemEquipModels (state, params) {

        let index_parent = state.equipModels.findIndex(item => item.id === params.parent_id)
        if(index_parent != -1) {
            let index_child = state.equipModels[index_parent].data.findIndex(item => item.id == params.id)

            if(index_child != -1) {
                state.equipModels[index_parent].data.splice(index_child, 1)
            }
        }
    },
    setcontractId(state,val){
        state.contractId = val;
    },
    setInfoRedirect(state,val){
        state.infoRedirect = val;
    },
    addListEquipment(state,data) {
        state.equipments.items =  [...state.equipments.items , data.data.data];
        state.equipments.total ++;
    },
    addTreeProperty(state,data) {
       state.dataTreeProperty = data;
    },
    addTreeStructure(state,data) {
        state.dataTreeStructure = data;
    },
    addFilter(state,data) {
        state.filter = data;
    },
    iniTreeEquipment(state,data){
        state.dataTreeProperty = [];
        state.dataTreeStructure = [];
        state.filter = {
            tag:null,
            model:null,
            brand:null,
            equipment_type:null,
            equipment_category:null,
            serial_number:null,
            location:null,
            location_id:null,
            equipment_category_id:null,
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
